import React, { useState } from "react";
import { Check, Loader2, ChevronRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "./ui/accordion";
import { Textarea } from "./ui/textarea";
import { toast } from "sonner";
import { PERKS, SOCIALS, FAQS, LEGAL } from "../mock";
import { Icon, CrownIcon } from "./Icons";

export function FollowModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[420px] rounded-2xl">
        <DialogTitle>Follow Maya</DialogTitle>
        <DialogDescription>Catch my daily life everywhere</DialogDescription>
        <div className="space-y-3 mt-2">
          {SOCIALS.map((s) => (
            <a key={s.id} href={s.url} target="_blank" rel="noreferrer" className="social-row" data-testid={`social-${s.id}`}>
              <Icon name={s.id} className="w-6 h-6 text-[#ee3a70]" />
              <span className="flex-1"><span className="block font-semibold text-[15px]">{s.name}</span><span className="text-[13px] text-[#7a7276]">{s.handle}</span></span>
              <ChevronRight className="w-5 h-5 text-[#b0a8ac]" />
            </a>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function FaqModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[520px] rounded-2xl">
        <DialogTitle className="text-[22px]">Frequently asked questions</DialogTitle>
        <Accordion type="single" collapsible className="mt-1">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`f${i}`}>
              <AccordionTrigger className="text-left text-[15px] hover:text-[#ee3a70] hover:no-underline" data-testid={`faq-q-${i}`}>{f.q}</AccordionTrigger>
              <AccordionContent className="text-[14px] text-[#5a5256]">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </DialogContent>
    </Dialog>
  );
}

export function LegalModal({ kind, onOpenChange }) {
  const [msg, setMsg] = useState({ email: "", text: "" });
  const send = (e) => {
    e.preventDefault();
    if (!msg.email || !msg.text) return toast.error("Please fill both fields");
    toast.success("Message sent! We'll get back soon.");
    setMsg({ email: "", text: "" });
    onOpenChange(false);
  };
  return (
    <Dialog open={!!kind} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[460px] rounded-2xl">
        {kind === "contact" ? (
          <>
            <DialogTitle>Contact</DialogTitle>
            <form onSubmit={send} className="space-y-3">
              <Input data-testid="contact-email" placeholder="Your email" value={msg.email} onChange={(e) => setMsg({ ...msg, email: e.target.value })} />
              <Textarea data-testid="contact-message" placeholder="Your message" rows={4} value={msg.text} onChange={(e) => setMsg({ ...msg, text: e.target.value })} />
              <button type="submit" className="btn-join w-full" data-testid="contact-send">Send</button>
            </form>
          </>
        ) : kind ? (
          <>
            <DialogTitle>{LEGAL[kind].title}</DialogTitle>
            <p className="text-[14px] leading-relaxed text-[#4a4246]">{LEGAL[kind].body}</p>
          </>
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
